<!-- 
	uses layout "./layouts/Dashboard.vue" .
 -->

<template>
	<div>

		<!-- Header  -->
		<div class="profile-nav-bg" style="background-image: url('/images/bg-profile.jpg')"></div>
		
        
		<!-- <a-row type="flex" :gutter="24" style="margin-top: -170px; padding-left: 30px; padding-right: 30px;">
			<a-col :span="24" :md="24" class="mb-24" >
				<a-card :bordered="false" class="header-solid h-full" :bodyStyle="{paddingTop: 0, paddingBottom: '16px' }">
                    <template #title>
                        <h6 class="font-semibold m-0">{{ $t('appointment-review-page.request-list-title')}}</h6>
                    </template>
                </a-card>                                    
			</a-col>
		</a-row> -->

        <a-row type="flex" :gutter="24" style="margin-top: -170px; padding-left: 30px; padding-right: 30px;">
			<a-col :span="24" :md="24" class="mb-24" style="display: flex; align-items: center; justify-content: center;">
				<h3 class="m-0" style="color: white; font-weight: 600 !important">{{ $t('appointment-page-subtitle.' + this.type )}}</h3>
			</a-col>
		</a-row>

        <a-row type="flex" :gutter="24" style="margin-top: 20px; padding-left: 30px; padding-right: 30px;" >
            <appointment-grid-item 
                v-for="(item, i) in data" 
                :key="i" 
                :appointment="item" 
            />
        </a-row>

	</div>
</template>

<script>

import { host, appointmentsClient } from '../../api/config';
import { toastMixin } from '../../mixins/ToastMixin';
import AppointmentGridItem from '../../views/appointments/AppointmentGridItem.vue';

export default {
    props: {
        type: String,
        default: ''
    },
    components: {
        AppointmentGridItem
    },
    mixins: [ toastMixin ],
    data() {
        return {
            data: [],
        }
    },
    methods: {
        processResponse(res) {
            if (!res.networkError) {
                if (res.status == 200) {
                    this.processAndSetList(res.body.list);      
                } else {
                    this.errorToast(this.$t('toast-error-messages.error') + res.status);
                }
            } else {
                this.errorToast(this.$t('toast-error-messages.network-error'));
            }
        },
        processAndSetList(list) {
            list.forEach(apt => {
                if (apt.visitor) {
                    if (apt.visitor.imageUrl == "") 
                        apt.visitor.imageUrl = 'images/default-avatar.jpg';
                    else
                        apt.visitor.imageUrl = host + apt.visitor.imageUrl;
                }
                if (apt.official) {
                    if (apt.official.imageUrl == "") 
                        apt.official.imageUrl = 'images/default-avatar.jpg';
                    else
                        apt.official.imageUrl = host + apt.official.imageUrl;
                }
            });
            this.data = list;
        },
        setLoading() {
            this.data = [
                { isLoading: true }, { isLoading: true }, { isLoading: true },
                { isLoading: true }, { isLoading: true }, { isLoading: true },
                { isLoading: true }, { isLoading: true }, { isLoading: true },
            ];
        },
        fetch() {
            if (this.type == 'today-online') {
                this.setLoading();
                let data = { 'page': 1, size: 200, type: 'ONLINE' }
                appointmentsClient.fetchAllConfirmedOfToday(data).then(res => {
                    this.processResponse(res); 
                });
            } else if (this.type == 'today-in-person') {
                this.setLoading();
                let data = { 'page': 1, size: 200, type: 'IN_PERSON' }
                appointmentsClient.fetchAllConfirmedOfToday(data).then(res => {
                    this.processResponse(res);
                });
            } else if (this.type == 'today-requests') {
                this.setLoading();
                let data = { 'page': 1, size: 200, status: 'APPLIED' }
                appointmentsClient.fetchAllOfToday(data).then(res => {
                    this.processResponse(res);
                });
            } else if (this.type == 'this-week-online') {
                this.setLoading();
                let data = { 'page': 1, size: 200, type:'ONLINE' };
                appointmentsClient.fetchAllConfirmedOfThisWeek(data).then(res => {
                    this.processResponse(res);
                });
            } else if (this.type == 'this-week-in-person') {
                this.setLoading();
                let data = { 'page': 1, size: 200, type: 'IN_PERSON' };
                appointmentsClient.fetchAllConfirmedOfThisWeek(data).then(res => {
                    this.processResponse(res);
                });
            } else if (this.type == 'this-week-requests') {
                this.setLoading();
                let data = { 'page': 1, size: 200, status: 'APPLIED' };
                appointmentsClient.fetchAllOfThisWeek(data).then(res => {
                    this.processResponse(res);
                });
            } else if (this.type == 'this-month-online') {
                this.setLoading();
                let data = { 'page': 1, size: 200, type:'ONLINE' };
                appointmentsClient.fetchAllConfirmedOfThisMonth(data).then(res => {
                    this.processResponse(res);
                });
            } else if (this.type == 'this-month-in-person') {
                this.setLoading();
                let data = { 'page': 1, size: 200, type: 'IN_PERSON' };
                appointmentsClient.fetchAllConfirmedOfThisMonth(data).then(res => {
                    this.processResponse(res);
                });
            } else if (this.type == 'this-month-requests') {
                this.setLoading();
                let data = { 'page': 1, size: 200, status: 'APPLIED' };
                appointmentsClient.fetchAllOfThisMonth(data).then(res => {
                    this.processResponse(res);
                });
            }

        }
    },
    // watch: {
    //     type: {
    //         immediate: true,
    //         handler() {
                
    //         }
    //     },
    // },
    mounted() {
        this.fetch()
    }
}

</script>

<style lang="scss">
</style>